import React, { useEffect, useState } from "react";
import { case_1, case_2, case_3, case_4, case_5 } from "../..";
import { useLocation } from "react-router-dom";

const organizations = [
  {
    id: 0,
    org_Img: case_1,
    org_title:
      "How Spence prevented six-figure losses by securing employee access",
    org_num: "99.9%",
    org_subtitle: "Uptime Secured",
    org_link: "#",
  },
  {
    id: 1,
    org_Img: case_2,
    org_title:
      "How Hamilton strengthened vendor security in under 30 days",
    org_num: "12x",
    org_subtitle: "Faster Incident Response",
    org_link: "#",
  },
  {
    id: 2,
    org_Img: case_3,
    org_title: "How DeltaTech’s mobile-first platform became breach-resistant",
    org_num: "3",
    org_subtitle: "Year Retention Boost",
    org_link: "#",
  },
];
const organizations2 = [
  {
    id: 0,
    org_Img: case_1,
    org_title:
      "How we helped a fintech firm prevent future attacks after a critical data leak.",
    org_num: "98%",
    org_subtitle: "Threat Reduction",
    org_link: "#",
  },
  {
    id: 1,
    org_Img: case_4,
    org_title:
      "How a logistics company scaled globally while staying fully compliant and secure.",
    org_num: "10x",
    org_subtitle: "Compliance Coverage",
    org_link: "#",
  },
  {
    id: 2,
    org_Img: case_5,
    org_title: "Helping a SaaS startup secure users worldwide with just a 40-hour monthly effort.",
    org_num: "100%",
    org_subtitle: "Secured Growth",
    org_link: "#",
  },
];
// console.log(organizations);
function OrganisationCard() {
  const location = useLocation();
  const { pathname } = location;
  const [isDisplay, setIsDisplay] = useState(false);

  useEffect(() => {
    if (pathname === "/") {
      setIsDisplay(true);
    } else if (pathname === "/services/vulnerability-assessment-service") {
      setIsDisplay(false);
    } else {
      setIsDisplay(true);
    }
  }, [pathname]);
  return (
    <div className="row">
      {isDisplay ? (
        <>
          {organizations.map((item, index) => {
            return (
              <div className="orgCard" key={index}>
                <div className="innerOrgCard">
                  <div className="orgImgWrap">
                    <a href={item.org_link}>
                      <img
                        src={item.org_Img}
                        alt={item.org_subtitle}
                        className="img-fluid"
                      />
                      <div className="overlay"></div>
                    </a>
                  </div>
                  <a href={item.org_link} className="orgLink">
                    <h3>{item.org_title}</h3>
                  </a>
                  <h4>{item.org_num}</h4>
                  <p>{item.org_subtitle}</p>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <>
          {organizations2.map((item, index) => {
            return (
              <div className="orgCard" key={index}>
                <div className="innerOrgCard">
                  <div className="orgImgWrap">
                    <a href={item.org_link}>
                      <img
                        src={item.org_Img}
                        alt={item.org_subtitle}
                        className="img-fluid"
                      />
                      <div className="overlay"></div>
                    </a>
                  </div>
                  <a href={item.org_link} className="orgLink">
                    <h3>{item.org_title}</h3>
                  </a>
                  <h4>{item.org_num}</h4>
                  <p>{item.org_subtitle}</p>
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}

export default OrganisationCard;
